import React, { Fragment } from 'react'
import {
  Frame,
  SpacerVertical,
} from '@klarna/bubble-ui'
import LegalText from '../../components/LegalText/LegalText'
import PaymentMethod from '../PaymentMethod/PaymentMethod'
import PaymentMethodDetails from '../PaymentMethodDetails/PaymentMethodDetails'
import PaymentMethodWithProgress from '../PaymentMethodWithProgress/PaymentMethodWithProgress'
import isAnyValueEmpty from '../../utilities/isAnyValueEmpty'

type PaymentMethodProps = {
  badge: string
  purchaseAmount: string
  backgroundColorKey: string
  frequencyTitle?: string
  installmentAmount?: string
}

type PaymentMethodDetailsProps = {
  installmentsTotal: string
  totalTranslation: string
  apr: string
  aprParagraph: string
  aprTranslation: string
  interestTranslation?: string
  interestFreeTranslation?: string
  interestAmount?: string
  downPayment?: string
  downPaymentTranslation?: string
  finalPayment?: string
  finalPaymentTranslation?: string
}

type PaymentMethodWithProgressProps = {
  badge: string
  purchaseAmount: string
  backgroundColorKey: string
  frequencySteps: string
  frequencyTitle: string
  breakdown: string
  installmentAmount: string
}

type PaymentMethodContainerProps = {
  heading?: string
  frameBackground: string
  legalText: string
  paymentMethodProps?: PaymentMethodProps
  paymentMethodWithProgressProps?: PaymentMethodWithProgressProps
  paymentMethodDetailsProps?: PaymentMethodDetailsProps
};

const PaymentMethodContainer: React.FC<PaymentMethodContainerProps> = ({
  frameBackground = '',
  legalText = '',
  paymentMethodProps = null,
  paymentMethodWithProgressProps = null,
  paymentMethodDetailsProps = null
}) => {
  const shouldDisplayPM = !isAnyValueEmpty(paymentMethodProps || paymentMethodWithProgressProps)

  return (
    <Fragment>
      { shouldDisplayPM ? (
        <Fragment>
          <Frame backgroundColorToken={frameBackground} paddingToken="space.none">
            {paymentMethodProps ? <PaymentMethod {...paymentMethodProps} /> : null}
            {paymentMethodWithProgressProps ? <PaymentMethodWithProgress {...paymentMethodWithProgressProps} /> : null}
            {paymentMethodDetailsProps ? <PaymentMethodDetails {...paymentMethodDetailsProps} /> : null}
          </Frame>
          <SpacerVertical spaceToken="space.100" />
          <LegalText legalText={legalText} />
        </Fragment>
      ) : null }

    </Fragment>
  )
}

export default PaymentMethodContainer
